export function getUTCDateFromToday(days: number): string {
    const date = new Date()
    date.setUTCDate(date.getUTCDate() + days)
    return date.toISOString()
}
